import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getEmployeeReportsTo = async () => {
  return axios.get(
    `${api_base_url}/EmployeeConfiguration/EmployeeReportsTo`
  ).then((res) => {
    return res;
  });
};

export const addEmployeeReportsTo = async (newEmployeeReportsTo) => {
  return axios.post(`${api_base_url}/EmployeeConfiguration/EmployeeReportsTo`, {
    ...newEmployeeReportsTo,
  });
};

export const updateEmployeeReportsTo = async (editEmpReportsto) => {
  const {data} = await axios.put(
    `${api_base_url}/EmployeeConfiguration/UpdateEmployeeReportsTo`,
    editEmpReportsto
  );
  return data;
};

export const deactivateEmployeeReportsTo = async (ids) => {
  const {data} = await axios.delete(
    `${api_base_url}/EmployeeConfiguration/EmployeeReportsTo`,
    {
      data: ids,
    }
  );
  return data;
};
